'use strict';

var _toConsumableArray = require("/codebuild/output/src2043515612/src/labourteq/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

module.exports = {
  // underscore replacements:
  isNull: isNull,
  isObject: isObject,
  unique: unique,
  flatten: flatten
};
/*
 * Helper functions which were created to remove underscorejs from this package.
 */

function isObject(value) {
  return typeof value === 'object';
}

function isNull(value) {
  return value === null;
}

function unique(array) {
  return _toConsumableArray(new Set(array));
}

function flatten(array) {
  var _ref;

  return (_ref = []).concat.apply(_ref, _toConsumableArray(array));
}